import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-icon_status_stopped_warn",
  "use": "svg-icon-icon_status_stopped_warn-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-icon_status_stopped_warn\"><rect width=\"12\" height=\"12\" rx=\"1\" fill=\"#E68B00\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol